<!-- Property of OSF GLOBAL SERVICES INC. , an OSF Digital company. OSF remains the sole owner of all right, title and interest in the software. Do not copy, sell, reverse engineer or otherwise attempt to derive or obtain information about the functioning, manufacture or operation therein. -->

<style lang="scss" scoped>
.accordion__item {
  padding: .625rem 1.25rem .625rem 2.5rem;
  border-bottom: .1875rem solid #eee;
  position: relative;
  cursor: default;
}

.pointer {
  cursor: pointer;
}

.accordion__trigger {
  display: flex;
  justify-content: space-between;
}

.accordion-enter-active,
.accordion-leave-active {
  will-change: height, opacity;
  transition: height 0.3s ease, opacity 0.3s ease;
  overflow: hidden;
}

.accordion-enter,
.accordion-leave-to {
  height: 0 !important;
  opacity: 0;
}
</style>

<template>
    <li class="accordion__item">
        <div
            class="accordion__trigger"
            :class="[{ accordion__trigger_active: visible }, { pointer: clickable }]"
            @click="open"
        >
            <!-- This slot will handle the title/header of the accordion and is the part you click on -->
            <slot name="accordion-trigger" />
        </div>

        <transition
            name="accordion"
            @enter="start"
            @after-enter="end"
            @before-leave="start"
            @after-leave="end"
        >
            <div
                v-show="visible"
                class="accordion__content"
            >
                <ul>
                    <!-- This slot will handle all the content that is passed to the accordion -->
                    <slot name="accordion-content" />
                </ul>
            </div>
        </transition>
    </li>
</template>

<script>
export default {
    props: {
        clickable: Boolean,
        item: Object
    },
    inject: ['Accordion'],
    data() {
        return {
            index: null
        };
    },
    computed: {
        visible() {
            return this.item.current;
        },
        quizData() {
            return this.$store.state.quizData;
        }
    },
    mounted() {
        this.index = this.Accordion.count;
        this.Accordion.count += 1;
        this.Accordion.active = this.item.current;
    },
    methods: {
        async open() {
            if (this.clickable) {
                if (this.visible) {
                    this.Accordion.active = null;
                } else if (this.quizData.navBtns) {
                    this.gotoQuestion(
                        this.item.id,
                        this.item.current,
                        this.item.answered
                    ).then(() => { this.Accordion.active = this.index; });
                }
            }
        },
        gotoQuestion: async function (id, current, answered) {
            if (!current && answered) {
                this.$store.dispatch('gotoQuestion', id);
            }
        },
        start(el) {
            var newParam = el;
            newParam.style.height = el.scrollHeight + 'px';
        },
        end(el) {
            var newParam = el;
            newParam.style.height = '';
        }
    }
};
</script>
